import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchMentorshipOffered } from '../store/mentorshipSlice';

// Cache duration in milliseconds (24 hours)
const CACHE_DURATION = 24 * 60 * 60 * 1000;

export const useMentorship = () => {
  const dispatch = useDispatch();
  const { data: mentorshipOffered, loading, error, lastFetched } = useSelector(
    (state) => state.mentorship
  );

  useEffect(() => {
    // Check if we need to fetch mentorship offerings
    const shouldFetch = 
      mentorshipOffered.length === 0 || 
      !lastFetched || 
      Date.now() - lastFetched > CACHE_DURATION;

    if (shouldFetch && !loading) {
      dispatch(fetchMentorshipOffered());
    }
  }, [dispatch, mentorshipOffered.length, loading, lastFetched]);

  // Function to manually refresh mentorship offerings
  const refreshMentorship = () => {
    dispatch(fetchMentorshipOffered());
  };

  return {
    mentorshipOffered,
    loading,
    error,
    refreshMentorship,
  };
};

// Hook for searching mentorship offerings with caching
export const useMentorshipSearch = () => {
  const { mentorshipOffered, loading } = useMentorship();

  const searchMentorship = (query) => {
    if (!query) return mentorshipOffered;
    
    return mentorshipOffered.filter(item => 
      item.name?.toLowerCase().includes(query.toLowerCase()) ||
      item.title?.toLowerCase().includes(query.toLowerCase())
    );
  };

  return {
    searchMentorship,
    loading,
  };
};
